export default __webpack_public_path__ + "static/media/lemontbotanique_background_l1.535076a2.jpg";